// TradingViewWidget.jsx

import React, { useEffect, useRef } from 'react';

let tvScriptLoadingPromise: Promise<Event>;

export default function TradingViewWidget({  symbol}: { symbol:string}) : JSX.Element {
  const onLoadScriptRef = useRef<(()=>void)|null>(null);

  useEffect(() => {

    function createWidget() {
        if (document.getElementById('tradingview_a1f01') && 'TradingView' in window) {
          new (window as any).TradingView.widget({
            autosize: true,
            symbol: symbol+".P",
            interval: "15",
            timezone: "Etc/UTC",
            theme: "dark",
            style: "1",
            locale: "en",
            toolbar_bg: "#f1f3f6",
            enable_publishing: false,
            hide_legend: true,
            save_image: false,
            container_id: "tradingview_a1f01"
          });
        }
      }
      
      onLoadScriptRef.current = createWidget;

      if (!tvScriptLoadingPromise) {
        tvScriptLoadingPromise = new Promise<Event>((resolve) => {
          const script = document.createElement('script');
          script.id = 'tradingview-widget-loading-script';
          script.src = 'https://s3.tradingview.com/tv.js';
          script.type = 'text/javascript';
          script.onload = resolve;

          document.head.appendChild(script);
        });
      }
      tvScriptLoadingPromise.then(() => onLoadScriptRef.current && onLoadScriptRef.current());
      return () => { onLoadScriptRef.current = null;}
    },
    [symbol]
  );

  return (
    <>
    <div  style={{'backgroundColor':'rgb(33, 37, 41)', 'padding':'4px'}}>
      { symbol !== '' && <><div className="tradingview-widget-copyright">
        <a href={"https://www.tradingview.com/"} rel="noopener noreferrer" target="_blank">
          <span className="blue-text">{symbol} chart</span></a> by TradingView
      </div>
    <div className='tradingview-widget-container' style={{marginBottom:'0.1rem'}}>       
      <div id='tradingview_a1f01' />
     </div></> }
     { symbol === '' && 
     <>
     <div className="tradingview-widget-copyright" style={{height:'32px'}}>
        <a href={"https://www.tradingview.com/"} rel="noopener noreferrer" target="_blank">
          <span className="blue-text"></span></a>
      </div>
     <div className='tradingview-widget-container d-flex align-items-center justify-content-center' style={{marginBottom:'0.1rem'}}>
        <h3 style={{color:'#efefef',  display:'flex'}}>Please select symbol</h3>
        </div></>}
    </div>
    </>
  );
}
